import { render, staticRenderFns } from "./TagDelete.vue?vue&type=template&id=17c1535b&scoped=true"
import script from "./TagDelete.vue?vue&type=script&lang=js"
export * from "./TagDelete.vue?vue&type=script&lang=js"
import style0 from "./TagDelete.vue?vue&type=style&index=0&id=17c1535b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c1535b",
  null
  
)

export default component.exports